import { Resource } from "../resource/resource.model";

export class PreferenceChannel  extends Resource {
    name: string;
    code: string;
    description: string;
    status: string;
    tenantId: string;
    createdAt: Date;
    updatedAt: Date;
}